import fittingApi from "src/api/fittingApi";

export const SET_FITTING_PUSH_BUTTON_FORM_REMOTE = "setFittingPushButtonFromRemote";
export const SET_FITTING_VOLUME_BUTTON_FORM_REMOTE = "setFittingVolumeButtonFromRemote";
export const SET_FITTING_PUSH_BUTTON = "setFittingPushButton";

export function setFittingPushButtonFromRemote() {
    return (dispatch) => {
        fittingApi.getPushButton().then((data) => {
            dispatch({
                type: SET_FITTING_PUSH_BUTTON_FORM_REMOTE,
                payload: { data }
            });
        });
    };
}

export function setFittingVolumeButtonFromRemote() {
    return (dispatch) => {
        fittingApi.getVolumeButton().then((data) => {
            dispatch({
                type: SET_FITTING_VOLUME_BUTTON_FORM_REMOTE,
                payload: { data }
            });
        });
    };
}


export function setFittingPushButton(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_PUSH_BUTTON,
            payload: { data }
        });
    };
}

export const SET_FITTING_VOLUME_BUTTON = "setFittingVolumeButton";
export function setFittingVolumeButton(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_VOLUME_BUTTON,
            payload: { data }
        });
    };
}
export const SET_FITTING_VOLUME_BEHAVIOR = "setFittingVolumeBehavior";
export function setFittingVolumeBehavior(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_VOLUME_BEHAVIOR,
            payload: { data }
        });
    };
}
export const SET_FITTING_STARTUP = "setFittingStartUp";
export function setFittingStartUp(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_STARTUP,
            payload: { data }
        });
    };
}
export const SET_FITTING_BEEP = "setFittingBeep";
export function setFittingBeep(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_BEEP,
            payload: { data }
        });
    };
}

export const SET_FITTING_CURVES_DATA = "setFittingCurvesData";

export function setFittingCurvesData(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_CURVES_DATA,
            payload: { data }
        });
    };
}
export const SET_FITTING_SETTING = "setFittingSetting";

export function setFittingSetting(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_SETTING,
            payload: { data }
        });
    };
}
export const SET_FITTING_REC = "setFittingRealEarCalibration";

export function setFittingRealEarCalibration(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_REC,
            payload: { data }
        });
    };
}

export const SET_FREQUENCY_BAND_GROUP = "setFrequencyBandGroup";
export function setFrequencyBandGroup(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FREQUENCY_BAND_GROUP,
            payload: { data }
        });
    };
}

export const SET_FITTING_MPO_DATA = "setFittingMPODATA";
export function setFittingMPODATA(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_MPO_DATA,
            payload: { data }
        });
    };
}

export const SET_FITTING_GAIN_DATA = "setFittingGainDATA";
export function setFittingGainDATA(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_GAIN_DATA,
            payload: { data }
        });
    };
}
export const SET_FITTING_COMPRESSION_DATA = "setFittingCompressionDATA";
export function setFittingCompressionDATA(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FITTING_COMPRESSION_DATA,
            payload: { data }
        });
    };
}

export const SET_BASIC_INITIAL_FITTING = "setBasicInitialfitting";
export function setBasicInitialfitting(data) {
    return (dispatch) => {
        dispatch({
            type: SET_BASIC_INITIAL_FITTING,
            payload: { data }
        });
    };
}

export const SET_BASIC_TINNITUS_BALANCE = "setBasictTinnitusBalance";
export function setBasictTinnitusBalance(data) {
    return (dispatch) => {
        dispatch({
            type: SET_BASIC_TINNITUS_BALANCE,
            payload: { data }
        });
    };
}

export const SET_SOUND_RECOVER = "setSoundRecover";
export function setSoundRecover(data) {
    return (dispatch) => {
        dispatch({
            type: SET_SOUND_RECOVER,
            payload: { data }
        });
    };
}
export const SET_BASS_BOOST = "setBassBoost";
export function setBassBoost(data) {
    return (dispatch) => {
        dispatch({
            type: SET_BASS_BOOST,
            payload: { data }
        });
    };
}

export const SET_OPTIONAL_CURVE_TYPES = "setOptionalCurveTypes";
export function setOptionalCurveTypes(data) {
    return (dispatch) => {
        dispatch({
            type: SET_OPTIONAL_CURVE_TYPES,
            payload: { data }
        });
    };
}

export const SET_SELECTED_UPDATERS = "setSelectedUpdaters";
export function setSelectedUpdaters(data) {
    return (dispatch) => {
        dispatch({
            type: SET_SELECTED_UPDATERS,
            payload: { data }
        });
    };
}

export const SET_FREQUENCY_COMPRESSION_INFO = "setFrequencyCompressionInfo";
export function setFrequencyCompressionInfo(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FREQUENCY_COMPRESSION_INFO,
            payload: { data }
        });
    };
}

export const SET_FREQUENCY_COMPRESSION_INFO_ENABLE = "setFrequencyCompressionInfoEnable";
export function setFrequencyCompressionInfoEnable(enable, side) {
    return (dispatch) => {
        dispatch({
            type: SET_FREQUENCY_COMPRESSION_INFO_ENABLE,
            payload: { enable, side }
        });
    };
}

export const SET_FREQUENCY_COMPRESSION_INFO_AUDIBILITY = "setFrequencyCompressionInfoAudibility";
export function setFrequencyCompressionInfoAudibility(value, side) {
    return (dispatch) => {
        dispatch({
            type: SET_FREQUENCY_COMPRESSION_INFO_AUDIBILITY,
            payload: { value, side }
        });
    };
}
export const SET_FREQUENCY_COMPRESSION_INFO_CLARITY = "setFrequencyCompressionInfoClarity";
export function setFrequencyCompressionInfoClarity(value, side) {
    return (dispatch) => {
        dispatch({
            type: SET_FREQUENCY_COMPRESSION_INFO_CLARITY,
            payload: { value, side }
        });
    };
}
export const SET_FREQUENCY_COMPRESSION_CURVE_INFO = "setFrequencyCompressionCurveInfo";
export function setFrequencyCompressionCurveInfo(data) {
    return (dispatch) => {
        dispatch({
            type: SET_FREQUENCY_COMPRESSION_CURVE_INFO,
            payload: { data }
        });
    };
}

export const SET_EASING_SOFT_UPDATERS = "setEasingSoftUpdaters";
export function setEasingSoftUpdaters(data) {
    return (dispatch) => {
        dispatch({
            type: SET_EASING_SOFT_UPDATERS,
            payload: { data }
        });
    };
}

export const SET_EASING_SOFT_SELECT_UPDATERS = "setEasingSoftSelectUpdaters";
export function setEasingSoftSelectUpdaters(data) {
    return (dispatch) => {
        dispatch({
            type: SET_EASING_SOFT_SELECT_UPDATERS,
            payload: { data }
        });
    };
}

export const SET_AVAILABLE_UPDATERS = "setAvailableUpdaters";
export function setAvailableUpdaters(data) {
    return (dispatch) => {
        dispatch({
            type: SET_AVAILABLE_UPDATERS,
            payload: { data }
        });
    };
}
export const SET_ALL_PROGRAMS = "setAllPrograms";
export function setAllPrograms(data) {
    return (dispatch) => {
        dispatch({
            type: SET_ALL_PROGRAMS,
            payload: { data }
        });
    };
}
export const SET_CUSTOM_PROGRAMS = "setCustomPrograms";
export function setCustomPrograms(data) {
    return (dispatch) => {
        dispatch({
            type: SET_CUSTOM_PROGRAMS,
            payload: { data }
        });
    };
}


